(function() {
    'use strict';

    angular.module('vobeApp').component('languageDropdownButton', {
        templateUrl: 'app/components/shopping-cart/language-dropdown/language-dropdown.html',
        controller: 'LanguageDropdownButtonController',
        controllerAs: 'vm',
        bindings: {
            shoppingCartConfigs: '<',
            currentProperty: '<',
            websiteType: '<',//group or property
        }
    });
})();
